import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterHorimetroKMAsync,
    enviarHorimetroKMAsync,
    editarHorimetroKMAsync,
	downloadLista
}

export const obterHorimetroKMAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/HorimetroKM/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson);
}

export const enviarHorimetroKMAsync = async (prefixo,apelido,hr_KM,dataHR,dataLancamento) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ prefixo, apelido, hr_KM, dataHR, dataLancamento})
    };
    return fetch(`${process.env.VUE_APP_API_URL}/HorimetroKM`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarHorimetroKMAsync = async (id, prefixo, apelido, hr_KM, dataHR, dataLancamento, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, prefixo, apelido, hr_KM, dataHR, dataLancamento, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/HorimetroKM/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export function downloadLista() {
	try {
		return axios({
			url: `${process.env.VUE_APP_ROOT_API}/HorimetroKM/downloadHorimetroKM`,
			method: 'GET',
			responseType: 'blob',
			headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
		}).catch(() => {
			return { status: false };
		})
			.then((response) => {
				if (response.status === false)
					return response;
				var fileURL = window.URL.createObjectURL(new Blob([response.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'HorimetroKM' + '.xlsx');
				document.body.appendChild(fileLink);

				fileLink.click();
			});
	} catch (e) {
		throw e;
	}
}